export enum ProductType {
  SingleGtin = 0,
  CompanyPrefixTen = 1,
  CompanyPrefixHundred = 2,
  CompanyPrefixThousand = 3,
  CompanyPrefixTenThousand = 4,
  CompanyPrefixHundredThousand = 5,
}
